import type { BankResponse } from 'mmfintech-backend-api/types'

export const createBankChangeHandler = (providedBanks: BankResponse[] | undefined, formValues: any) => {
  return (_: string, value: string) => {
    const found = providedBanks?.find((bank: BankResponse) => bank.id === Number(value))
    if (found) {
      formValues.setValue('bankName', found.name)
      formValues.setValue('bankCode', found.code)
    }
  }
}

export const getSelectedBankId = (providedBanks: BankResponse[] | undefined, bankName: string): number | undefined => {
  return providedBanks?.find((bank: BankResponse) => bank.name === bankName)?.id
}
